/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceVisibilityResponse {
    getFixupPrototypeFunction() { return ResourceVisibilityResponse.fixupPrototype; }

    static newInstance(model: Partial<ResourceVisibilityResponse>): ResourceVisibilityResponse {
        let obj = Object.assign(new ResourceVisibilityResponse(), model);
        ResourceVisibilityResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceVisibilityResponse>): ResourceVisibilityResponse {
        if (!model) return null;
        return ResourceVisibilityResponse.newInstance(<ResourceVisibilityResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceVisibilityResponse) {
        if (!obj) return;

        models.ResourceVisibilityResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceVisibilityResponse): boolean {
        Object.setPrototypeOf(obj, ResourceVisibilityResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.account_wise_count) {
            for (let val of this.account_wise_count) {
                models.PostureAccountModel.fixupPrototype(val);
            }
        }
        if (this.resource_wise_count) {
            for (let val of this.resource_wise_count) {
                models.PostureResourceModel.fixupPrototype(val);
            }
        }
        if (this.region_wise_count) {
            for (let val of this.region_wise_count) {
                models.PostureRegionModel.fixupPrototype(val);
            }
        }
        if (this.resource_group_wise_count) {
            for (let val of this.resource_group_wise_count) {
                models.PostureResourceGroupModel.fixupPrototype(val);
            }
        }
        if (this.category_wise_count) {
            for (let val of this.category_wise_count) {
                models.PostureCategoryModel.fixupPrototype(val);
            }
        }
    }

    /**
     * last sync time
     */
    last_sync_time: string;

    /**
     * List of account wise count data
     */
    account_wise_count: Array<models.PostureAccountModel>;

    /**
     * List of resource wise count data
     */
    resource_wise_count: Array<models.PostureResourceModel>;

    /**
     * List of region wise count data
     */
    region_wise_count: Array<models.PostureRegionModel>;

    /**
     * List of resource group wise data
     */
    resource_group_wise_count: Array<models.PostureResourceGroupModel>;

    /**
     * List of category wise data
     */
    category_wise_count: Array<models.PostureCategoryModel>;

}
